import {SvgService} from 'app/core/services/svg.service';

export function fetchSvgSourcesFactory(sources: SvgService) {
    return () => sources.init();
}
